import type { Issue, IssueExportColumn } from "../_types/issues.types";

const formatIssueExportTimestamp = (timestamp: number | null) =>
  timestamp === null ? "" : new Date(timestamp).toISOString();

export const ISSUE_EXPORT_COLUMNS: Array<IssueExportColumn> = [
  {
    key: "reporterName",
    label: "Reporter name",
    defaultSelected: true,
  },
  {
    key: "reporterEmail",
    label: "Reporter email",
    defaultSelected: true,
  },
  {
    key: "errorType",
    label: "Type",
    defaultSelected: true,
  },
  {
    key: "modelSlug",
    label: "Model slug",
    defaultSelected: true,
  },
  {
    key: "modelVersion",
    label: "Model version",
    defaultSelected: true,
  },
  {
    key: "description",
    label: "Description",
    defaultSelected: true,
  },
  {
    key: "id",
    label: "Issue ID",
  },
  {
    key: "userId",
    label: "Reporter user ID",
  },
  {
    key: "structureName",
    label: "Structure name",
  },
  {
    key: "structureId",
    label: "Structure ID",
  },
  {
    key: "structureCollection",
    label: "Structure collection",
  },
  {
    key: "latinName",
    label: "Latin name",
  },
  {
    key: "reportedAt",
    label: "Reported at",
    getValue: (issue) => formatIssueExportTimestamp(issue.reportedAt),
  },
  {
    key: "createdAt",
    label: "Created at",
    getValue: (issue) => formatIssueExportTimestamp(issue.createdAt),
  },
  {
    key: "read",
    label: "Read",
    getValue: (issue) => String(issue.read),
  },
  {
    key: "readByUserId",
    label: "Read by user ID",
  },
  {
    key: "readByName",
    label: "Read by name",
  },
  {
    key: "readAt",
    label: "Read at",
    getValue: (issue) => formatIssueExportTimestamp(issue.readAt),
  },
];

export const getIssueExportColumnValue = (issue: Issue, column: IssueExportColumn) =>
  column.getValue ? column.getValue(issue) : issue[column.key];
